import { z } from 'zod';

export const SubstanceKind = z.enum([
  'Mono',
  'Multi',
  'Copper',
  'ANALYTE1',
  'ANALYTE2',
  'ANALYTE3',
  'ANALYTE4',
  'ANALYTE5',
  'ANALYTE6',
  'ANALYTE7',
  'ANALYTE8',
  'ANALYTE9',
  'ANALYTE10',
  'ANALYTE11',
  'ANALYTE12',
  'ANALYTE13',
  'ANALYTE14',
  'ANALYTE15',
  'ANALYTE16',
  'ANALYTE17',
  'ANALYTE18',
  'ANALYTE19',
  'ANALYTE20',
  'ANALYTE21',
  'ANALYTE22',
  'ANALYTE23',
  'ANALYTE24',
  'ANALYTE25',
  'ANALYTE26',
  'ANALYTE27',
  'ANALYTE28',
  'ANALYTE29',
  'ANALYTE30',
  'ANALYTE31',
  'ANALYTE32',
  'ANALYTE33',
  'ANALYTE34',
  'ANALYTE35',
  'ANALYTE36',
  'ANALYTE37',
  'ANALYTE38',
  'ANALYTE39',
  'ANALYTE40',
  'ANALYTE41',
  'ANALYTE42',
  'ANALYTE43',
  'ANALYTE44',
  'ANALYTE45',
  'ANALYTE46',
  'ANALYTE47',
  'ANALYTE48',
  'ANALYTE49',
  'ANALYTE50',
  'ANALYTE51',
  'ANALYTE52',
  'ANALYTE53',
  'ANALYTE54',
  'ANALYTE55',
  'ANALYTE56',
  'ANALYTE57',
  'ANALYTE58',
  'ANALYTE59',
  'ANALYTE60',
  'ANALYTE61',
  'ANALYTE62',
  'ANALYTE63',
  'ANALYTE64',
  'ANALYTE65',
  'ANALYTE66',
  'ANALYTE67',
  'ANALYTE68',
  'ANALYTE69',
  'ANALYTE70',
  'ANALYTE71',
  'ANALYTE72',
  'ANALYTE73',
  'ANALYTE74',
  'ANALYTE75',
  'ANALYTE76',
  'ANALYTE77',
  'ANALYTE78',
  'ANALYTE79',
  'ANALYTE80',
  'ANALYTE81',
  'ANALYTE82',
  'ANALYTE83',
  'ANALYTE84',
  'ANALYTE85',
  'ANALYTE86',
  'ANALYTE87',
  'ANALYTE88',
  'ANALYTE89',
  'ANALYTE90',
  'ANALYTE91',
  'ANALYTE92',
  'ANALYTE93',
  'ANALYTE94',
  'ANALYTE95',
  'ANALYTE96',
  'ANALYTE97',
  'ANALYTE98',
  'ANALYTE99',
  'ANALYTE100',
  'ANALYTE101',
  'ANALYTE102',
  'ANALYTE103',
  'ANALYTE104',
  'ANALYTE105',
  'ANALYTE106',
  'ANALYTE107',
  'ANALYTE108',
  'ANALYTE109',
  'ANALYTE110',
  'ANALYTE111',
  'ANALYTE112',
  'ANALYTE113',
  'ANALYTE114',
  'ANALYTE115',
  'ANALYTE116',
  'ANALYTE117',
  'ANALYTE118',
  'ANALYTE119',
  'ANALYTE120',
  'ANALYTE121',
  'ANALYTE122',
  'ANALYTE123',
  'ANALYTE124',
  'ANALYTE125',
  'ANALYTE126',
  'ANALYTE127',
  'ANALYTE128',
  'ANALYTE129',
  'ANALYTE130',
  'ANALYTE131',
  'ANALYTE132',
  'ANALYTE133',
  'ANALYTE134',
  'ANALYTE135',
  'ANALYTE136',
  'ANALYTE137',
  'ANALYTE138',
  'ANALYTE139',
  'ANALYTE140',
  'ANALYTE141',
  'ANALYTE142',
  'ANALYTE143',
  'ANALYTE144',
  'ANALYTE145',
  'ANALYTE146',
  'ANALYTE147',
  'ANALYTE148',
  'ANALYTE149',
  'ANALYTE150',
  'ANALYTE151',
  'ANALYTE152',
  'ANALYTE153',
  'ANALYTE154',
  'ANALYTE155',
  'ANALYTE156',
  'ANALYTE157',
  'ANALYTE158',
  'ANALYTE159',
  'ANALYTE160',
  'ANALYTE161',
  'ANALYTE162',
  'ANALYTE163',
  'ANALYTE164',
  'ANALYTE165',
  'ANALYTE166',
  'ANALYTE167',
  'ANALYTE168',
  'ANALYTE169',
  'ANALYTE170',
  'ANALYTE171',
  'ANALYTE172',
  'ANALYTE173',
  'ANALYTE174',
  'ANALYTE175',
  'ANALYTE176',
  'ANALYTE177',
  'ANALYTE178',
  'ANALYTE179',
  'ANALYTE180'
]);

export const SubstanceKindLabels: Record<SubstanceKind, string> = {
  Mono: 'Mono-résidu',
  Multi: 'Multi-résidus',
  Copper: 'Cuivre',
  ANALYTE1: 'Acide carminique (e120)',
  ANALYTE2: 'Acide cyanhydrique',
  ANALYTE3: 'Acide érucique',
  ANALYTE4: 'Acide glycyrrhizique',
  ANALYTE5: 'Acrylamide',
  ANALYTE6: 'Acrylamide, furane & alkylfuranes',
  ANALYTE7: 'Acrylamide, furane & alkylfuranes, mcpd',
  ANALYTE8: 'Acrylamide, mcpd',
  ANALYTE9: 'Aflatoxine b1',
  ANALYTE10: 'Aflatoxines m1',
  ANALYTE11: 'Aflb1',
  ANALYTE12: 'Aflb1, ota',
  ANALYTE13: 'Ains',
  ANALYTE14: "Alcaloïdes de l'ergot",
  ANALYTE15: 'Alcaloïdes ergot/alcaloïdes tropaniques',
  ANALYTE16: 'Alcaloïdes opioïdes',
  ANALYTE17: 'Alcaloïdes pyrrolizidiniques',
  ANALYTE18: 'Alcaloïdes pyrrolizidiniques, alcaloïdes tropaniques',
  ANALYTE19: 'Alcaloïdes quinolizidinique',
  ANALYTE20: 'Alcaloïdes tropaniques',
  ANALYTE21: 'Amitraze et métabolites',
  ANALYTE22: 'Antibiotiques (chimie)',
  ANALYTE23: 'Antibiotiques (chimique) -benzimidazoles-ains',
  ANALYTE24: 'Antibiotiques (méthode biologique - lnr)',
  ANALYTE25: 'Anticoccidiens',
  ANALYTE26: 'Antithyroidiens',
  ANALYTE27: 'Antiviraux',
  ANALYTE28: 'Arsenic (+ arsenic inorganique), cadmium, plomb',
  ANALYTE29: 'As cd pb',
  ANALYTE30: 'Asi',
  ANALYTE31: 'Avermectines',
  ANALYTE32: 'Benzimidazoles et autres anthelmintiques',
  ANALYTE33: 'Béta-agonistes',
  ANALYTE34: 'Bisphénols',
  ANALYTE35: 'Caféine, mélatonine',
  ANALYTE36:
    'Campylobacter thermo-tolérant, e. coli indicatrices, e.coli productrices de blse, ampc ou carbapénèmases',
  ANALYTE37: "Carbamate d'éthyle",
  ANALYTE38: 'Cd',
  ANALYTE39: 'Cd, ni',
  ANALYTE40: 'Chloramphénicol',
  ANALYTE41: 'Chlordécone',
  ANALYTE42: 'Citrinine',
  ANALYTE43: 'Colorants',
  ANALYTE44: 'Colorants (hors tio2)',
  ANALYTE45: "Constituants d'origine animale (coa) par microscopie",
  ANALYTE46: "Constituants d'origine animale (coa) par pcr (adn ruminant)",
  ANALYTE47: 'Contamination croisée coccidiostats/subst. médicamenteuses',
  ANALYTE48: 'Curcumine (e100)',
  ANALYTE49: "Cyanure d'hydrogène",
  ANALYTE50:
    "Dépistage : constituants d'origine animale (coa) par microscopie / confirmation : constituants d'origine animale (coa) par pcr (adn ruminant)",
  ANALYTE51:
    "Dépistage : constituants d'origine animale (coa) par microscopie / confirmation :constituants d'origine animale (coa) par pcr (adn ruminant)",
  ANALYTE52: 'Dioxines,furanes, pcb',
  ANALYTE53: 'E. coli prod blse, ampc ou carbapénémases',
  ANALYTE54: 'E. coli stec',
  ANALYTE55: 'E. coli stec, salmonella',
  ANALYTE56: 'E.coli',
  ANALYTE57: "Ergot de seigle (sclérotes)alcaloïdes de l'ergot",
  ANALYTE58: 'Ergot de seigle (sclérotes)alcaloïdes ergot/ergot de seigle',
  ANALYTE59: "Ergot de seigle et alcaloïdes de l'ergot, alcaloïdes tropaniques",
  ANALYTE60: 'Erythritol (e968)',
  ANALYTE61: 'Esters de progestagènes',
  ANALYTE62: 'Esters stéroïdes',
  ANALYTE63: 'Fipronil et métabolites',
  ANALYTE64: 'Fipronil et métabolites, fenthion et métabolites, indoxacarb',
  ANALYTE65: 'Fluor',
  ANALYTE66: 'Furane & alkylfuranes',
  ANALYTE67: 'Glucocorticoïdes',
  ANALYTE68: 'Glycoalcaloïdes',
  ANALYTE69: 'Gth',
  ANALYTE70: "Had - émodine et/ou d'aloé-émodine et/ou d'[aloïnes a + b]",
  ANALYTE71: 'Hap',
  ANALYTE72: 'Hap, acrylamide',
  ANALYTE73: 'Hap, acrylamide, furane & alkylfuranes',
  ANALYTE74: 'Hap, acrylamide, furane & alkylfuranes, mcpd',
  ANALYTE75:
    'Hap, furan-2(5h)-one, styrène, benzofuran, benzene-1,2-diol (catechol)',
  ANALYTE76: 'Hap, furane & alkylfuranes, mcpd',
  ANALYTE77: 'Hap, mcpd',
  ANALYTE78: 'Hav et norovirus',
  ANALYTE79: 'Hg',
  ANALYTE80: 'Histamine',
  ANALYTE81: 'Impuretés botaniques',
  ANALYTE82: 'Iode',
  ANALYTE83: 'Itc, vto',
  ANALYTE84: 'Listeria',
  ANALYTE85: 'Listeria, salmonella',
  ANALYTE86: 'Mcpd',
  ANALYTE87: 'Mcpd libre',
  ANALYTE88: 'Mélamine',
  ANALYTE89: 'Mercure (hg)',
  ANALYTE90: 'Moh',
  ANALYTE91: 'Monacoline',
  ANALYTE92: 'Mycotoxines (méthode multirésidus)',
  ANALYTE93:
    "Mycotoxines (méthode multirésidus), alcaloïdes tropaniques et alcaloïdes de l'ergot",
  ANALYTE94: "Mycotoxines (méthode multirésidus), sclérotes d'ergot",
  ANALYTE95:
    "Mycotoxines (méthode multirésidus), sclérotes d'ergot et alcaloïdes de l'ergot",
  ANALYTE96:
    "Mycotoxines (méthode multirésidus), sclérotes d'ergot et alcaloïdes de l'ergot, alcaloïdes tropaniques",
  ANALYTE97: 'Mycotoxines par méthode multirésidus',
  ANALYTE98: 'Mycotoxines par méthode multirésidus, alcaloïdes tropaniques',
  ANALYTE99: 'Nickel',
  ANALYTE100: 'Nitrates',
  ANALYTE101: 'Nitrates, perchlorates',
  ANALYTE102: 'Nitrites',
  ANALYTE103: 'Nitrites/nitrates',
  ANALYTE104: 'Nitrofuranes',
  ANALYTE105: 'Nitroïmidazoles',
  ANALYTE106: 'Nutriment',
  ANALYTE107: 'Ochratoxines',
  ANALYTE108: 'Ogm non autorisés',
  ANALYTE109: 'Organochlorés et autres résidus de pesticides',
  ANALYTE110: 'Ota',
  ANALYTE111: 'Patuline',
  ANALYTE112: 'Pb',
  ANALYTE113: 'Pb, cd',
  ANALYTE114: 'Pb, cd, hg',
  ANALYTE115: 'Pb, cd, hg, asi, ni',
  ANALYTE116: 'Pb, cd, hg, ast',
  ANALYTE117: 'Pb, cd, hg, ast, asi, ni',
  ANALYTE118: 'Pb, cd, hg, ast, asi, ni, al',
  ANALYTE119: 'Pb, cd, hg, ast, asi, ni, al, i',
  ANALYTE120: 'Pb, cd, hg, ast, asi, ni, al, sn',
  ANALYTE121: 'Pb, cd, hg, ast, asi, ni, sn',
  ANALYTE122: 'Pb, cd, hg, ast, ni',
  ANALYTE123: 'Pb, cd, hg, ni',
  ANALYTE124: 'Pb, cd, hg, ni, al',
  ANALYTE125: 'Pb, cd, hg, ni, al, sn',
  ANALYTE126: 'Pb, cd, hg, ni, ast',
  ANALYTE127: 'Pb, cd, hg, ni, ast, i',
  ANALYTE128: 'Pb, hg',
  ANALYTE129: 'Pcb-ndl',
  ANALYTE130: 'Pcdd/f pcb-dl',
  ANALYTE131: 'Pcdd/f pcb-dl pcb-ndl',
  ANALYTE132: 'Pcdd/f pcb-dl, pcb-ndl',
  ANALYTE133: 'Perchlorates',
  ANALYTE134: 'Pesticides organochlorés et autres résidus de pesticides',
  ANALYTE135: 'Pfas',
  ANALYTE136: 'Phycotoxines lipophiles',
  ANALYTE137: 'Phycotoxines psp',
  ANALYTE138: 'Propoxur',
  ANALYTE139: 'Pulégone',
  ANALYTE140: 'Pyréthrinoïdes (deltaméthrine, cyperméthrine, perméthrine)',
  ANALYTE141: 'Pyréthrinoïdes (deltaméthrine, cyperméthrine)',
  ANALYTE142: 'Radionucléides sg fruit drom irsn',
  ANALYTE143: 'Radionucléides sg irsn',
  ANALYTE144: 'Radionucléides sg lda',
  ANALYTE145: 'Radionucléides sg lég feuille scl',
  ANALYTE146: 'Radionucléides sg riz camargue irsn',
  ANALYTE147: 'Radionucléides spin fruit irsn',
  ANALYTE148: 'Radionucléides spin irsn',
  ANALYTE149: 'Radionucléides spin non littoral irsn',
  ANALYTE150: 'Radionucléides surv générale irsn',
  ANALYTE151: 'Radionucléides surveillance générale poissons irsn',
  ANALYTE152: 'Radionucléides surveillance pin littoral irsn',
  ANALYTE153: 'Radionucléides surveillance zone remanence lda',
  ANALYTE154: 'Radionucléides surveillance zr lda',
  ANALYTE155: 'Radionucléides szr scl',
  ANALYTE156: 'Radionucléidesremanence lda',
  ANALYTE157: 'Rbst',
  ANALYTE158:
    'Résidus de pesticides (plan européen) analyses multi et monorésidus',
  ANALYTE159:
    'Résidus de pesticides (plan national) analyses multirésidus + certains monorésidus (voir it)',
  ANALYTE160: 'Résidus emballage',
  ANALYTE161: 'Résidus pesticides daoa - composés de cuivre',
  ANALYTE162: 'Résidus pesticides daoa - mono et multirésidus',
  ANALYTE163:
    'Résidus pesticides daoa - monorésidus + multirésidus (fipronil, famoxadone, boscalid)',
  ANALYTE164: 'Résidus pesticides daoa - monorésidus et multirésidus',
  ANALYTE165: 'Résidus pesticides daoa - multirésidus',
  ANALYTE166: 'Salmonella',
  ANALYTE167: 'Stilbènes, stéroïdes, acides résorcycliques',
  ANALYTE168:
    'Substances autorisées diverses (antibiotiques (sm-hr) /benzimidazoles/tranquillisants/ains/anticoccidiens (méthode multi-résidus hrms - plan inovalys 56)',
  ANALYTE169:
    'Substances autorisées diverses (antibiotiques (sm-hr) /benzimidazoles/tranquillisants/ains/anticoccidiens (méthode multi-résidus hrms - plan lnr 35)',
  ANALYTE170: 'Substances médicamenteuses',
  ANALYTE171: 'Sulfamides',
  ANALYTE172: 'Sulfites',
  ANALYTE173: 'Thc, cbd',
  ANALYTE174: 'Tio2',
  ANALYTE175: 'Tio2 gélule',
  ANALYTE176: "Toxines d'alternaria",
  ANALYTE177: 'Traitement ionisant',
  ANALYTE178: 'Tranquilisants',
  ANALYTE179: 'Zear/och/trich/fum/don',
  ANALYTE180:
    'Zéaralénone, ochratoxine a, trichothécènes a et b dont don, t2-ht2, fumonisine b1 et b2'
};

export const AdditionalSubstanceKindList = SubstanceKind.options.filter(
  (_) => !['Mono', 'Multi'].includes(_)
);

export type SubstanceKind = z.infer<typeof SubstanceKind>;
